<div class="acknowledgement-dialog">
	<span class="h1 acknowledgement-header" translate="user.settings.acknowledgements"></span>
	<stages-ai-acknowledgements (acknowledgementsState)="closeDialog($event)" [processVersion]="processVersion()" />
</div>
